import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Flex, Typography } from 'antd';

class PointsUpdate extends Component {
    constructor(props) {
        super(props);

    }

    componentWillMount() {

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    shouldComponentUpdate(nextProps, nextState) {

    }

    componentWillUpdate(nextProps, nextState) {

    }

    componentDidUpdate(prevProps, prevState) {

    }

    componentWillUnmount() {

    }

    render() {
        return (
            <div>
                <Flex gap="middle" justify='center' align='center'>
                    <Typography.Title style={{ marginTop: 0 }} level={3}>Coming Soon</Typography.Title>
                </Flex>
            </div>
        );
    }
}


export default PointsUpdate;